import moment from "moment";
import React, { useEffect, useState } from "react";
import { academylist } from "../../../services/admin";
import Select from "react-select";
import { createenquiry, detailenquiry } from "../../../services/common";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function Addenquiry() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [addr, setAddress] = useState("");
  const [fname, setFName] = useState("");
  const [pinst, setPInst] = useState("");
  const [edate, setEDate] = useState("");
  const [ereason, setEReason] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (path === "enquirydetail") {
      detailenquiry(id).then((res) => {
        if (res.status === true) {
          setName(res.data.student_name);
          setMobile(res.data.phone);
          setAddress(res.data.address);
          setFName(res.data.father_name);
          setPInst(res.data.previous_institute);
          setEReason(res.data.enquiry_reason);
          setEDate(moment(res.data.enquiry_date).format("YYYY-MM-DD"));
          academylist().then((res1) => {
            if (res1.status === true) {
              let arr = [];
              if (res1.data.details.length > 0) {
                for (let i = 0; i < res1.data.details.length; i++) {
                  if (res1.data.details[i].id == res.data.academy_id) {
                    arr.push({
                      value: res1.data.details[i].id,
                      label:
                        res1.data.details[i].name + " - " + res1.data.details[i].code,
                    });
                  }

                }
                setAcaID(arr[0]);
              }
            }
          });
        }
      });
    } else {
      if (localStorage.getItem("ADate") !== '') {
        setEDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      } else {
        setEDate(moment(new Date()).format("YYYY-MM-DD"));
      }
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                }
              }
             
            }
          }
        });
      }

    }
  }, [location.pathname]);

  function handlePhone(e) {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setMobile(e.target.value);
    }
  }
  const [succmsg, setSuccmsg] = useState(false);
  function submitenquiry(e) {
    e.preventDefault();
    setSuccmsg(true);
    if (
      name !== "" &&
      mobile !== "" &&
      addr !== "" &&
      fname !== "" &&
      pinst !== "" &&
      edate !== ""
    ) {
      setLoading(true);
      const temp = new FormData();
      temp.append("student_name", name);
      temp.append("father_name", fname);
      temp.append("phone", mobile);
      temp.append("previous_institute", pinst);
      temp.append("address", addr);
      temp.append("enquiry_reason", ereason);
      temp.append("enquiry_date", edate);
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy_id", acaid.value);
      }
      if (urllink === "enquirydetail") {
        temp.append("id", id);
      }
      createenquiry(temp).then((res) => {
        if (res.status === true) {
          setLoading(false);
          setSuccmsg(false);
          navigate("/enquiry/allenquiry");
          toast.success(res.message);
        } else {
          setLoading(false);
          setSuccmsg(false);
          toast.error(res.message);
        }
      });
    }
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
    } else {
      setAcaID("");
    }
  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">
          {urllink === "addenquiry" ? "Add Enquiry" : "Enquiry Details"}
        </h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Admission Enquiry</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {urllink === "addenquiry" ? "Add Enquiry" : "Enquiry Details"}
          </li>
        </ol>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  {urllink === "addenquiry" ? "Add Enquiry" : "Enquiry Details"}
                </h2>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={aclist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                            {succmsg && acaid === "" && (
                              <span className="text-danger">
                                Please Select Academy
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Student Name<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Student Name"
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                          />
                          {succmsg && name === "" && (
                            <span className="text-danger">
                              Please Enter Student Name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Phone Number"
                            value={mobile}
                            onChange={handlePhone}
                            maxLength={10}
                          />
                          {succmsg && mobile === "" && (
                            <span className="text-danger">
                              Please Enter Mobile Number
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Father Name<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Father Name"
                            onChange={(e) => setFName(e.target.value)}
                            value={fname}
                          />
                          {succmsg && fname === "" && (
                            <span className="text-danger">
                              Please Enter Father Name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Previous Institute
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Previous Institute"
                            onChange={(e) => setPInst(e.target.value)}
                            value={pinst}
                          />
                          {succmsg && pinst === "" && (
                            <span className="text-danger">
                              Please Enter Previous Institute
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address<span className="text-danger"> *</span>
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Enter Address"
                            onChange={(e) => setAddress(e.target.value)}
                            value={addr}
                          />
                          {succmsg && addr === "" && (
                            <span className="text-danger">
                              Please Enter Address
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Enquiry Reason
                            {/* <span className="text-danger"> *</span> */}
                          </label>
                          <textarea
                            className="form-control"
                            rows={4}
                            placeholder="Enter Enquiry Reason"
                            onChange={(e) => setEReason(e.target.value)}
                            value={ereason}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Date<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setEDate(e.target.value)}
                            value={edate}
                          />
                          {succmsg && edate === "" && (
                            <span className="text-danger">
                              Please Select Date
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="res-right mt-4 me-4 mb-4">
              <button className="btn btn-success me-2" onClick={submitenquiry}>
                Submit
              </button>
              {urllink !== "addenquiry" && (
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate("/enquiry/allenquiry")}
                >
                  Back
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
